import { PricingPackage, PackageList } from '~shared/types/pricing/pricingsvc';
import { FeatureSet } from '~shared/types/pricing/features';
import { Packages } from '~shared/constants/pricing';

export enum PackageType {
  Individual = 'individual',
  Teams = 'teams',
  Educational = 'educational',
  Enterprise = 'enterprise',
}

type Currency = {
  code: string;
};

export type PackageSkuCost = {
  skuType: string;
  cost: number;
  currency: Currency;
};

export type PackageSkuCosts = PackageSkuCost[];

export enum PACKAGE_PRICE_TYPE {
  SUMMARY = 'Summary',
  DETAIL = 'Detail',
  COMPARISON = 'Comparison',
}

export type PACKAGE_PRICE_TYPE_KEYS = keyof typeof PACKAGE_PRICE_TYPE;
export type PACKAGE_PRICE_TYPE_VALUES = `${PACKAGE_PRICE_TYPE}`;
export type DisplayString = React.ReactElement | string | undefined;
export type PackageData = PricingPackage;
export type PackageDataSet = PackageData[];
export type PackageSet = Packages[];

export type PackagesHook = {
  allPackages: PricingPackage[];
  userPackage: PricingPackage;
  displayPackages: PricingPackage[];
  showEduDiscount: boolean;
  packagesToDisplay: Packages[];
  comparePlans: boolean;
  overageCost: PackageSkuCost | undefined;
  getPackageById(packageId: number | string): PricingPackage;
};

export type PackageMap = Record<number, PricingPackage>;

export type PackagesProviderProps = {
  packagesToDisplay: PackageList;
  showEduDiscount: boolean;
  comparePlans: boolean;
  children: React.ReactNode;
};

export type PackageProps = {
  packageName: Packages;
  skuCost: PackageSkuCosts;
  comparisonSkuCost: PackageSkuCosts;
  ribbonText?: string | boolean | null;
  features: FeatureSet;
  comparePlans: boolean;
  isLastPackage: boolean;
};

export type RoutePackageMap = {
  [x: string]: PackageSet;
};
